import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Cpu, MemoryStick, HardDrive, Network, Gauge, Activity } from 'lucide-react';

const LiveMetricsMonitor = ({ metricsData }) => {
    const { t } = useLanguage();
    const [metricsHistory, setMetricsHistory] = useState([]);

    useEffect(() => {
        if (metricsData) {
            setMetricsHistory(prev => {
                const newHistory = [...prev, { ...metricsData, timestamp: new Date() }];
                // Son 10 ölçümü tut
                return newHistory.slice(-10);
            });
        }
    }, [metricsData]);

    const LiveMetricGauge = ({ icon: Icon, label, value, max = 100, unit = '%', color = '#3B82F6' }) => {
        const percentage = Math.min((value / max) * 100, 100);

        const getStatusColor = (value, max) => {
            if (value > max * 0.8) return '#EF4444';
            if (value > max * 0.6) return '#F59E0B';
            return '#10B981';
        };

        const statusColor = getStatusColor(value, max);

        return (
            <div className="live-metric-gauge">
                <div className="gauge-header">
                    <Icon size={18} />
                    <span className="gauge-label">{label}</span>
                </div>
                <div className="gauge-container">
                    <div className="gauge-background">
                        <div
                            className="gauge-fill"
                            style={{
                                height: `${percentage}%`,
                                backgroundColor: statusColor
                            }}
                        ></div>
                    </div>
                    <div className="gauge-value">
                        {value} {unit}
                    </div>
                </div>
                <div className="gauge-footer">
                    <div className="gauge-min">0{unit}</div>
                    <div className="gauge-max">{max}{unit}</div>
                </div>
            </div>
        );
    };

    return (
        <div className="live-metrics-monitor">
            <div className="monitor-header">
                <Activity size={20} />
                <h3>{t('systemHealthLiveMetrics')}</h3>
                <div className="live-indicator">
                    <div className="pulse-dot"></div>
                    {t('systemHealthLive')}
                </div>
            </div>

            <div className="metrics-gauges">
                <LiveMetricGauge
                    icon={Cpu}
                    label={t('systemHealthCPUUsage')}
                    value={metricsData?.cpuUtilization || 0}
                    color="#EF4444"
                />
                <LiveMetricGauge
                    icon={MemoryStick}
                    label={t('systemHealthMemoryUsage')}
                    value={metricsData?.memoryUsage || 0}
                    color="#10B981"
                />
                <LiveMetricGauge
                    icon={HardDrive}
                    label={t('systemHealthDiskUsage')}
                    value={metricsData?.diskUsage || 0}
                    color="#F59E0B"
                />
                <LiveMetricGauge
                    icon={Network}
                    label={t('systemHealthNetworkThroughput')}
                    value={metricsData?.networkThroughput || 0}
                    max={1000}
                    unit="MB/s"
                    color="#8B5CF6"
                />
                <LiveMetricGauge
                    icon={Gauge}
                    label={t('systemHealthResponseLatency')}
                    value={metricsData?.responseLatency || 0}
                    max={500}
                    unit="ms"
                    color="#EC4899"
                />
                <LiveMetricGauge
                    icon={Activity}
                    label={t('systemHealthConcurrentConnections')}
                    value={metricsData?.activeConnections || 0}
                    max={100}
                    unit=""
                    color="#06B6D4"
                />
            </div>

            <div className="metrics-history">
                <h4>{t('metric_hisroty')}</h4>
                <div className="history-chart">
                    {/* Basit bir çizgi grafik simülasyonu */}
                    <div className="chart-container">
                        {metricsHistory.map((metric, index) => (
                            <div
                                key={index}
                                className="history-point"
                                style={{
                                    left: `${(index / (metricsHistory.length - 1 || 1)) * 100}%`,
                                    bottom: `${(metric.cpuUtilization / 100) * 100}%`
                                }}
                                title={`CPU: ${metric.cpuUtilization}%`}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LiveMetricsMonitor;